import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import CanvasCharacter from './CanvasCharacter/CanvasCharacter';
import classes from './Characters.module.css';

import clsx from 'clsx';
import { FaForward } from 'react-icons/fa6';
import SoundPlayer from 'react-sdk/SoundPlayer';
import Texts from 'react-sdk/Texts';
import { Dial } from '../../js/Dials';
import Button from '../shared/Button/Button';


const Characters = ({dials}) => {
  const [dialEnded, setDialEnded] = useState(false);

  const loading = dials.loading

  /** @type {Dial} */
  const dial = dials.currentDial
  if(!dial) return
  console.log("dial", dial)
  //const dialBG = dial.element.line.get("bg")
  const dialAudio = dial.element.line.get("Audio")
  const dialText = dial.element.line.get("Text")
  const char = dial.element.line.get("Character")

  const characterIds = Array.from(dials.loadedCharIds)

  const dialBg = dial.element.line.get("bg")
  const dialImage = dial.element.line.get("image")

  if(dial.element.isChoice())
    SoundPlayer.playSound("dial_choice")
  else
    SoundPlayer.playSound("dial_pop")

  /*useEffect(() => {

    dialBG = dial.element.line.get("bg")
    dialAudio = dial.element.line.get("Audio")
    dialText = dial.element.line.get("Text")
    dialType = dial.element.line.get("Type")

      return () => { }



    }, []);*/

  function nextDial() {
    dial.subtitle = null
    setDialEnded(false)
    dials.nextDial()  
  }

  function onDialEnd(skipped) {
    console.log("onDialEnd skipped : " + skipped)
    setDialEnded(true)
    // if (skipped) 
      nextDial()

  }

  function handleSkip(e) {
    e.stopPropagation()

    console.log("handleSkip dialEnded : " + dialEnded)
    if (dialEnded)
      nextDial()
    else
      dial.charRef.current.skipSegment()
    
  }

  console.log("characterIds", characterIds)
  return (

    <div className={clsx(classes.Characters, "Characters")}>
      <>
        {dialBg
        ?
        <div
        className={clsx(classes.dial_bg, "dial_bg")}
        style={{backgroundImage: `url(${dialBg})`}} />
        :
        <div
        className={clsx(classes.dial_overlay, "dial_overlay")} />}

        {dialImage &&
        <div className={clsx(classes.dial_image, "dial_image")} >
          <img src={`${dialImage}`} alt="" />
        </div>}

        {dial &&
        characterIds.map(id => {
          return <CanvasCharacter char_id={id} dial={dial} loading={loading} onEnd={onDialEnd} key={id} />
        })}
    </>


      {!dial.element.isChoice() && dial?.subtitle &&
      <div className={clsx(classes.subtitle, "subtitle")} onClick={handleSkip}>
        <div className={clsx(classes.char_name, "char_name", classes[char])} dangerouslySetInnerHTML={{__html : Texts.get(char)}} />
        <div className={clsx(classes.subtitle_text, "subtitle_text")} dangerouslySetInnerHTML={{__html: dial.subtitle}} />

        <FaForward className={clsx(classes.forward, "forward")} />
      </div>}


      {dial.element.isChoice() &&
        <div className={clsx(classes.choices, "choices")}>
          <div className={clsx(classes.choice_title, "choice_title")}>
            {dialText}
          </div>
          <div className={clsx(classes.choice_buttons, "choice_buttons")}>
            {dial.element.choices.map(choice => {
              return (
              <Button className={clsx(classes.choice_btn, "choice_btn")} key={choice.id} onClick={() => {
                dial.element.addAnswer(choice.getId())
                dials.nextDial()
                SoundPlayer.playSound("dial_answer")
              }}>
                {choice.line.get("Text")}
              </Button>)
            })}
          </div>
        </div>}

      {/* {loading &&
      <div className={clsx(classes.dial_loading, "dial_loading")}>
        <Loader />
      </div>} */}

    </div>



  );
};

export default observer(Characters)
